import { Component, Input } from '@angular/core';
import { AlertLevel, AlertMessage } from 'src/app/core/Dtos/alert.entity';
import { MorayEastBidOfferPairDTO } from 'src/app/core/Dtos/moray-east/bid-offer-pair-dto';
import { MorayEastInstructionDTO } from 'src/app/core/Dtos/moray-east/instructions-dto';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { DateFormatHelperService } from 'src/app/core/services/date-format-helper.service';
import { MorayEastService } from 'src/app/core/services/moray-east.service';
import { UserService } from 'src/app/core/user.service';

@Component({
  selector: 'app-moray-east-viewer',
  templateUrl: './moray-east-viewer.component.html',
  styleUrl: './moray-east-viewer.component.scss',
  standalone: false
})
export class MorayEastViewerComponent {
  @Input() public set InstructionId(instructionId: string | number) {
    if (instructionId !== 0)
      this.GetInstruction(instructionId);
    this._instructionId = instructionId;

  };
  public Instruction: MorayEastInstructionDTO = new MorayEastInstructionDTO();
  public RelevanPeriods: string[] = [];

  private _instructionId: string | number = '';

  constructor(
    private _morayEastService: MorayEastService,
    private _alertService: AlertsService,
    public DateFormatHelper: DateFormatHelperService,
    public UserService: UserService,) {
  }

  GetInstruction(instructionId: string | number) {
    this._morayEastService.GetInstructionById(instructionId).subscribe(
      resp => {
        this.Instruction = resp;
        this.GetRelevantSettlementPeriods(resp.bidOfferPairs);
      }
    )
  }

  GetRelevantSettlementPeriods(BidOfferPairs: MorayEastBidOfferPairDTO[]) {
    this.RelevanPeriods = BidOfferPairs.map(bo => bo.periodId == 0 ? "All" : bo.startTime + " - " + bo.endTime)
  }

  ChangeStatus(status: string) {
    this._morayEastService.ChangeStatus(this._instructionId, status).subscribe(
      resp => {
        this.GetInstruction(this._instructionId);
      }
    )
  }

  ApplyToEDT() {
    this._morayEastService.ApplyToEDT(this._instructionId).subscribe({
      next: () => {
        this._alertService.ShowAlert(new AlertMessage(AlertLevel.Information, 'Instruction applied to EDT successfully.'));
        this.GetInstruction(this._instructionId);
      },
      error: () => {
        this._alertService.ShowAlert(new AlertMessage(AlertLevel.Error, 'Failed to apply instruction to EDT.'));
      }
    });
  }
}
